
export const DEMO_SECCION_INICIO_ZONA_FAN = {
    id: 'seccion_inicio_zona_fan',
    class: '',
    items: [
        {
            imagen: {
                imgSrc: 'https://picsum.photos/536/354',
                imgAlt: 'titulo texto alternativo',
                linkHref: 'https://www.duacode.com/es/',
                linkTitle: 'https://www.google.es/',
                class: 'isotipo-velado'
            },
            titulo: {
                titleTag: 'h3',
                titleText: 'Zona Fan',
                linkHref: 'https://www.duacode.com/es/',
                linkTitle: 'https://www.google.es/',
                class: 'section-tit2 isotipo-stroke'
            },
            textoPlano: {
                class: '',
                texto: 'Un gran espacio de ocio infantil y familiar abre sus puertas en Galicia, una propuesta lúdica única, dotada con todos los servicios para hacer realidad fiestas, celebraciones y toda clase de eventos. Más de 3000m2  al aire libre y un espacio cubierto de 1000m2 donde disfrutar de numerosas actividades. '
            },
            boton: {
                buttonClass: 'btn-secondary',
                buttonText: 'Descubre más',
                linkHref: 'https://www.duacode.com/es/',
                linkTitle: 'https://www.google.es/',
                class: 'botonEspecial'
            }
        }
    ]
};
export const DEMO_SECCION_COMUNIONES_COMUNIONES = {
    id: 'seccion_comuniones_comuniones',
    class: '',
    items: [
        {
            imagen: {
                imgSrc: 'https://picsum.photos/536/354',
                // imgSrc: 'http://htdocs.local/matrix-php/data/blog/3/images/_mini/blockfeatured/1/imagenbloquefeature3.png?t=20220322143317',
                imgAlt: 'titulo texto alternativo',
                linkHref: 'https://www.duacode.com/es/',
                linkTitle: 'https://www.google.es/',
                class: 'imagenEspecial'
                },
            // titulo: {
            //     titleTag: 'h2',
            //     titleText: 'Comuniones',
            //     linkHref: 'https://www.duacode.com/es/',
            //     linkTitle: 'https://www.google.es/',
            //     class: 'imagenEspecial'
            //   },
            textoPlano: {
                class: 'textoEspecial',
                texto: 'Zona Fan es el espacio ideal para celebrar un día tan especial con tus amigos y familia. 3000m2 de actividades al aire libre y 1000m2 de zona cubierta para que la diversión y los buenos momentos estén garantizados                 Reserva la finca en exclusiva para tu gran día y personaliza tu evento con todos los servicios y actividades que te proponemos: photocall, mesas dulces, karaoke, DJ, búsqueda del tesoro, magia, gimkanas… '
            },
            boton: {
                buttonClass: 'btn-primary',
                buttonText: 'Más información',
                linkHref: '/contacto',
                linkTitle: 'https://www.google.es/',
                class: 'botonEspecial'
            }
        }
    ]
};
